

import { httpRequest } from "../../http";

export class CommandLoginExternal {

    async run(token: string) {
        const data = {
            token
        };
        try {
           const request = await httpRequest<any>(`${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/auth/token-login/`, {
                method: "POST",
                body: data,
                auth: false
            });
            return request;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    } 

}

